/**
 * The evidence a RequirementCompletion carries must match its type's mechanic
 * on write (piece 13, Trainings and certifications; decision 0088): a Training
 * row carries only sourceQuizAttemptId, a Document row only certificateFileId,
 * an Attestation row only attestedByPersonId. 🔨 Nothing is marked complete
 * with no evidence at all. This is the pure half of the rule; the service that
 * writes the row runs it first and then checks the Document's file.
 */
export type RequirementMechanic = 'Training' | 'Document' | 'Attestation';

export interface RequirementEvidence {
  sourceQuizAttemptId?: string | null;
  certificateFileId?: string | null;
  attestedByPersonId?: string | null;
}

export const EVIDENCE_COLUMN: Readonly<Record<RequirementMechanic, keyof RequirementEvidence>> = {
  Training: 'sourceQuizAttemptId',
  Document: 'certificateFileId',
  Attestation: 'attestedByPersonId',
};

const EVIDENCE_COLUMNS = Object.values(EVIDENCE_COLUMN) as readonly (keyof RequirementEvidence)[];

/** The reason the row is refused, or null when the evidence is exactly the mechanic's own column. */
export function requirementEvidenceProblem(mechanic: RequirementMechanic, evidence: RequirementEvidence): string | null {
  const present = EVIDENCE_COLUMNS.filter((column) => evidence[column] !== null && evidence[column] !== undefined && evidence[column] !== '');
  const wanted = EVIDENCE_COLUMN[mechanic];
  if (present.length === 0) return `a ${mechanic} completion is recorded with ${wanted}; nothing is marked complete with no evidence`;
  if (present.length > 1) return `a ${mechanic} completion carries ${wanted} alone, not ${present.join(' and ')}`;
  if (present[0] !== wanted) return `a ${mechanic} completion is recorded with ${wanted}, not ${present[0]}`;
  return null;
}
